import styled from 'styled-components'
import { MathFormulaDisplay } from '@edulastic/common'

export const AnswerBox = styled(MathFormulaDisplay)`
  width: auto;
`
